import { findIndex, filter, forEach } from 'lodash';
import Skill from '../models/skill';

export function checkMobile() {
  var check = false;
  (function(a){
    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor);

  return check;
}

export function checkIOS() {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].indexOf(navigator.platform) != -1
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

export function getNextQuestion(questions, questionId) {
  if (questionId) {
    var index = findIndex(questions, function(item) {
      return item.id == parseInt(questionId)
    })
    return index + 1 < questions.length ? index + 1 : -1
  }
  return questions.length ? 0 : -1
}

export function getPreviousQuestion(questions, questionId) {
  if (questionId) {
    var index = findIndex(questions, function(item) { return item.id == parseInt(questionId) })
    return index - 1 >= 0 ? index - 1 : -1
  }
  return questions.length ? 0 : -1
}

export function getFirstQuestion(questions) {
  return questions.length ? 0 : -1
}

export function getLastQuestion(questions) {
  return questions.length ? questions.length - 1 : -1
}

export function getAnswerValuesForQuestion(answers, questionId) {
  var indexAnswer = findIndex(answers, function(o) { return o.questionId == questionId })
  if (indexAnswer != -1) {
    return answers[indexAnswer].value
  }
  return []
}

export function getAnswerForQuestion(answers, questionId) {
  var indexAnswer = findIndex(answers, function(o) { return o.questionId == questionId })
  if (indexAnswer != -1) {
    return answers[indexAnswer]
  }
  return null
}

export function getPassAnswer(answerItems) {
  var result = filter(answerItems, (o) => { return o.correct && o.name != 'point'})
  return result ? result.length : 0
}

export function jsUcfirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function titleCase(str) {
  var convertToArray = str.toLowerCase().split(' ');
  var result = convertToArray.map(function(val) {
    return val.replace(val.charAt(0), val.charAt(0).toUpperCase());
  });

  return result.join(' ');
}

export function secondsToHms(d) {
  d = Number(d);
  var h = Math.floor(d / 3600);
  var m = Math.floor(d % 3600 / 60);
  var s = Math.floor(d % 3600 % 60);

  var hDisplay = h > 0 ? h + "h " : "";
  var mDisplay = m > 0 ? m + "m " : "";
  var sDisplay = s > 0 ? s + "s" : "";
  return hDisplay + mDisplay + sDisplay;
}

export function secondsToHmsNumber(d) {
  d = Number(d);
  var h = Math.floor(d / 3600);
  var m = Math.floor(d % 3600 / 60);
  var s = Math.floor(d % 3600 % 60);

  var pad = (n: number) => String(n).padStart(2, "0");
  return h > 0 ? `${pad(h)}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
}

export function timeToHourMinutes(timeValue: number){
  const totalMinutes = Math.floor(timeValue / 60)
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes - hours * 60
  return {
    hours, minutes
  }
}


export async function asyncSleep(time){
  return await new Promise(s => setTimeout(s, time))
}

// Read a JSON body without assuming the server actually sent JSON. Rails answers
// with an HTML error page for 4xx/5xx (CSRF failures, 404, 500), and calling
// response.json() on that surfaces "Unexpected token '<'" instead of the real
// problem. Returns null when the body is not JSON so callers can fall back to
// the status code.
export async function readJsonResponse(response: Response): Promise<any | null> {
  if (!(response.headers.get('content-type') || '').includes('application/json')) return null

  try {
    return await response.json()
  } catch {
    return null
  }
}